import { createContext } from 'react'

const CollapsibleScoreboardContext = createContext<boolean>(false)

export default CollapsibleScoreboardContext
